// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e25f36ea","833":"75f881e3"}[chunkId] + ".chunk.js";
};